import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {useApi} from '../hooks/useApi'
import {RootState} from './rootReducer'
import {AuthContextInterface} from '../components/AuthProvider'

export type Product = {
  priceId: string
  productId: string
  name: string
  amount: number
  tax: Tax
  address: Address
  metadata: Metadata
}

type Metadata = {
  accessLevel: string
  accessType: string
  audience: string
  displayName: string
  duration: string
}

type Tax = {
  absolute: number
  taxRateId: string
}

type Address = {
  address1: string
  city: string
  state: string
  postalCode: string
  source: string
}

//#region types
type SliceState = {
  product?: Product
  error: string | null | undefined
}
//#endregion

//#region api
type GetOnetimeProductPayload = {
  auth: AuthContextInterface
  priceId: string
}
export const getOnetimeProduct = createAsyncThunk<
  any,
  GetOnetimeProductPayload
>('checkout/onetime/get', async ({auth, priceId}) => {
  const endpoint = `/v1/are/checkout/product/${priceId}/onetime`

  return useApi(auth, endpoint, {
    method: 'GET',
  }).then(res => res.json())
})
type ComfirmOnetimePaymentPayload = {
  auth: AuthContextInterface
  product?: Product
  courseId: string
  courseName: string
  isExamScheduled: string
  challengeId: number
  processPayment: boolean
  paymentMethodId: string
}
export const confirmOnetimeProduct = createAsyncThunk<
  any,
  ComfirmOnetimePaymentPayload
>(
  'checkout/onetime/confirm',
  async ({
    auth,
    product,
    courseId,
    challengeId,
    processPayment,
    isExamScheduled,
    courseName,
    paymentMethodId,
  }) => {
    const endpoint = `/v1/are/checkout/onetime`

    const body = {
      ...product,
      courseId,
      challengeId,
      processPayment,
      isExamScheduled,
      courseName,
      paymentMethodId,
    }

    return useApi(auth, endpoint, {
      method: 'POST',
      body: JSON.stringify(body),
    }).then(res => res.text())
  },
)
//#endregion

//#region slice
const initialState: SliceState = {
  product: undefined,
  error: undefined,
}

export default createSlice({
  name: 'checkout',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getOnetimeProduct.fulfilled, (state, action) => {
      const product = action.payload
      if (product) {
        product.tax.absolute = Math.floor(product.tax.absolute)

        state.product = product
        state.error = undefined
      }
    })
    builder.addCase(getOnetimeProduct.pending, state => {
      state.product = undefined
      state.error = undefined
    })
  },
})
//#endregion

//#region selectors
export const selectProduct = ({checkout}: RootState) => checkout.product
//#endregion
